import { useMemo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    fetchDatasets,
    gridDatasetSelector,
    createFetchGridDataset
} from '@libs/datasets';
import { makeSideEffectCallback } from '@libs/makeContext';

import {
    MonthlyTimesheetsProvider,
    useMonthlyTimesheetsState
} from './useMonthlyTimesheets';
import { MONTHLY_ALL_ATTENDANCE } from 'timeAndAttendance/redux.datasets';
import { DOMAIN_NAME } from 'timeAndAttendance/common';
import { StatusLegend } from 'timeAndAttendance/components';
import { setTimesheetExportContext } from '../exportContext';
import Filters from './Filters';
import UsersTimesheet from './UsersTimesheet';
import Pagination from './Pagination';

/** Publishes the view's current filters for the export modal to pre-fill. */
const ExportContextSync = () => {
    const { year, month, email, filters } = useMonthlyTimesheetsState();
    useEffect(() => {
        setTimesheetExportContext('monthly', {
            year,
            month,
            email,
            branch: filters?.branch || ''
        });
    }, [year, month, email, filters]);
    return null;
};

const TimesheetsMonthlyView = () => {
    const { data, currentPage, totalPages } = useSelector((state) =>
        gridDatasetSelector(state, DOMAIN_NAME, MONTHLY_ALL_ATTENDANCE)
    );
    const dispatch = useDispatch();
    const fetchMonthlyAllAttendance = useCallback(
        () => dispatch(fetchDatasets(MONTHLY_ALL_ATTENDANCE)),
        [dispatch]
    );
    const fetchGridMonthlyAllDataset = useCallback(
        (payload) =>
            dispatch(
                createFetchGridDataset(
                    DOMAIN_NAME,
                    MONTHLY_ALL_ATTENDANCE
                )(payload)
            ),
        []
    );

    const initialize = useCallback(
        (state) => ({
            ...state,
            data,
            totalPages,
            currentPage
        }),
        [currentPage, totalPages, data]
    );

    const middlewareProps = useMemo(
        () => ({
            fetchData: makeSideEffectCallback(fetchGridMonthlyAllDataset)
        }),
        []
    );

    useEffect(() => {
        fetchMonthlyAllAttendance();
    }, []);

    return (
        <MonthlyTimesheetsProvider
            initialize={initialize}
            middlewareProps={middlewareProps}
        >
            <ExportContextSync />
            <Filters />
            <StatusLegend sx={{ px: 2, pb: 1.5 }} />
            <UsersTimesheet />
            <Pagination />
        </MonthlyTimesheetsProvider>
    );
};

export default TimesheetsMonthlyView;
